import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../../Helpers/RgbColorHelper";

export default function Summary_1({ item, isSub }) {
  const isHtml = item.scale.isHtml;
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper
  const colors = getScaleColors(item.scale);

  return (
    <Row style={{ height: Number(item.height), marginBottom: "2px" }}>
      <Col xs={4}>
        <Row className={"justify-content-between"}>
          <Col className={!isSub ? "_main-scope-name-pdf-new" : "_sub-scope-names-pdf-new"}>
            {rgbEnabled ? (
              <span style={{ color: !isSub ? colors.dark : colors.primary, fontWeight: "bold" }}>{item.name}</span>
            ) : (
              item.name
            )}
          </Col>
          <Col xs={"auto"}>
            <div
              className={isSub ? "_sub-scope-score-pdf-new _flex-center" : "_main-scope-score-pdf-new _flex-center"}
              style={
                rgbEnabled
                  ? {
                      backgroundColor: colors.primary,
                      color: "#ffffff",
                      border: `1px solid ${colors.dark}`,
                    }
                  : {}
              }
            >
              {elementScore}
            </div>
          </Col>
        </Row>
      </Col>
      <Col xs={8}>
        <Row>
          {item.scale.ranges.map((range, i) => {
            const isHit = range.isHit;
            return (
              <Col
                key={i}
                className={
                  rgbEnabled
                    ? isHit
                      ? "_scale-style-pdf-new _flex-center" // RGB enabled: no hit classes to avoid conflicts
                      : "_scale-style-pdf-new _flex-center"
                    : isHit
                      ? isSub
                        ? "_scale-style-pdf-new _hit-sub-scale-new _flex-center" // Original: hit sub scale
                        : "_scale-style-pdf-new _hit-scale-new _flex-center" // Original: hit main scale
                      : "_scale-style-pdf-new _flex-center" // Original: no hit
                }
                style={
                  rgbEnabled && isHit
                    ? {
                        backgroundColor: colors.light,
                        borderColor: colors.primary,
                        border: `2px solid ${colors.primary}`,
                        color: colors.dark,
                        fontWeight: "bold",
                      }
                    : {}
                }
              >
                {isHtml ? <div dangerouslySetInnerHTML={{ __html: item.monoSpaceHtml }} /> : range.text}
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
}
